import { useState } from 'react';

// Shared lightbox state: open/close + prev/next cycling over a list of images
const useLightbox = (imagesLength) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const open = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const close = () => setIsOpen(false);

  const prev = () => {
    setCurrentIndex((i) => (i === 0 ? imagesLength - 1 : i - 1));
  };

  const next = () => {
    setCurrentIndex((i) => (i === imagesLength - 1 ? 0 : i + 1));
  };

  return { isOpen, currentIndex, open, close, prev, next };
};

export default useLightbox;
